import { GlAlert, GlDrawer, GlLink, GlSprintf } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { renderGFM } from '../../../../../../../app/assets/javascripts/behaviors/markdown/render_gfm.js?vue3';
import { destroyImageLightbox } from '../../../../../../../app/assets/javascripts/behaviors/markdown/render_image_lightbox.js?vue3';
import { helpPagePath } from '~/helpers/help_page_helper';
import { DRAWER_Z_INDEX } from '~/lib/utils/constants';
import { getContentWrapperHeight } from '~/lib/utils/dom_utils';
import SafeHtml from '~/vue_shared/directives/safe_html';
export default {
    name: 'ReadinessDrawer',
    directives: {
        SafeHtml
    },
    components: {
        GlAlert,
        GlDrawer,
        GlLink,
        GlSprintf
    },
    props: {
        isOpen: {
            type: Boolean,
            required: true
        },
        feedbackHtml: {
            type: String,
            required: false,
            default: null
        }
    },
    emits: [
        'close',
        'opened'
    ],
    computed: {
        headerHeight () {
            return getContentWrapperHeight();
        },
        hasFeedback () {
            return Boolean(this.feedbackHtml?.trim());
        }
    },
    watch: {
        isOpen: {
            handler (newVal) {
                if (newVal) {
                    this.renderMarkdown();
                } else {
                    // The drawer body unmounts on close, so release its lightbox before it goes.
                    this.destroyMarkdown();
                }
            },
            immediate: true
        },
        feedbackHtml () {
            // Feedback is only requested once the drawer opens, so it usually arrives after `isOpen`.
            this.renderMarkdown();
        }
    },
    beforeDestroy () {
        this.destroyMarkdown();
    },
    methods: {
        async renderMarkdown () {
            await this.$nextTick();
            renderGFM(this.$refs['gfm-content']);
        },
        destroyMarkdown () {
            if (this.$refs['gfm-content']) destroyImageLightbox(this.$refs['gfm-content']);
        },
        focusHeading () {
            this.$refs.heading?.focus();
            this.$emit('opened');
        }
    },
    DRAWER_Z_INDEX,
    readinessHelpPath: helpPagePath('user/work_items/workplan.md', {
        anchor: 'readiness-score'
    })
};
